var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const rsaEncryption = (cardNumber, publicKeyPem) => __awaiter(void 0, void 0, void 0, function* () {
    const encodedText = new TextEncoder().encode(cardNumber);
    const binaryDer = window.atob(publicKeyPem.replace(/(-----(BEGIN|END) PUBLIC KEY-----|\n)/g, ''));
    const binaryKey = Uint8Array.from(binaryDer, (val) => val.charCodeAt(0));
    try {
        const cryptoKey = yield window.crypto.subtle.importKey('spki', binaryKey.buffer, { name: 'RSA-OAEP', hash: 'SHA-512' }, true, ['encrypt']);
        const encryptedData = yield window.crypto.subtle.encrypt({ name: 'RSA-OAEP' }, cryptoKey, encodedText);
        const encryptedBase64 = btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
        return encryptedBase64;
    }
    catch (error) {
        return '';
    }
});
